<template>
  <div id="app" class="clearfix_" style="background:#fff;">
    <div v-if="isBlock1"><headerNav></headerNav></div>
    <router-view v-if="isRouterAlive">

    </router-view>
    <pcFooter v-if="isBlock2"></pcFooter>
  </div>
</template>

<script>
  import Vue from 'vue'
  import headerNav from '@/components/index/headerNav'
  import pcFooter from '@/components/index/pcFooter'
  export default {
    name: 'App',
    provide(){
      return{
        reload:this.reload
      }
    },
    data () {
      return {
        isBlock1:true,
        isBlock2:true,
        isRouterAlive:true
      }
    },
    components:{
      headerNav,pcFooter
    },
    watch:{
      $route(to,from){
        if(to.path=='/setPassword1'||to.path=='/loginHome'||to.path=='/setPassword2'||to.path=='/setPassword3'||to.path=='/setPassword4'||to.path=='/err404'){
          this.isBlock1=false
          this.isBlock2=false
        }else{
          this.isBlock1=true
          this.isBlock2=true
        }
        if(to.path=='/goodslist'){
          this.$store.commit('fff','')
          this.$store.commit('eee','')
          this.$store.commit('ggg',{pricesmall:'',pricebig:''})
        }
        if(to.path=='/generalTemplate1'||to.path=='/newYear'||to.path=='/nationalDay'||to.path=='/viewReturns'||to.path=='/userAgreement'||to.path=='/privacyAgreement'||to.path=='/christmasTemplate'||to.path=='/JuneOneTemplate'||to.path=='/project'||to.path=='/dragonBoatFestival'||to.path=='/returnGoodsList'||to.path=='/replacementGoods'||to.path=='/storedValueCard'||to.path=='/modifyMobilePhone'||to.path=='/memberScore'||to.path=='/memberBalance'||to.path=='/myEvaluation'||to.path=='/evaluateOrder'||to.path=='/articleList'||to.path=='/articleItem'||to.path=='/member'||to.path=='/order'||to.path=='/orderDetails'||to.path=='/collections'||to.path=='/footprint'||to.path=='/information'||to.path=='/address'||to.path=='/allTenant'||to.path=='/payPassword'){
          this.isBlock2=false
        }
      }
    },
    mounted:function () {
      this.headernone()
    },
    methods:{
      reload:function(){
        this.isRouterAlive=false
        this.$nextTick(function(){
          this.isRouterAlive=true
        })
      },
      headernone:function () {
        if(this.$route.path=='/setPassword1'||this.$route.path=='/loginHome'||this.$route.path=='/setPassword2'||this.$route.path=='/setPassword3'||this.$route.path=='/setPassword4'||this.$route.path=='/err404'){
          this.isBlock1=false
          this.isBlock2=false
        }else{
          this.isBlock1=true
          this.isBlock2=true
        }
        if(this.$route.path=='/goodslist'){
          this.$store.commit('fff','')
          this.$store.commit('eee','')
          this.$store.commit('ggg',{pricesmall:'',pricebig:''})
        }
        if(this.$route.path=='/generalTemplate1'||this.$route.path=='/newYear'||this.$route.path=='/nationalDay'||this.$route.path=='/viewReturns'||this.$route.path=='/userAgreement'||this.$route.path=='/privacyAgreement'||this.$route.path=='/christmasTemplate'||this.$route.path=='/JuneOneTemplate'||this.$route.path=='/project'||this.$route.path=='/dragonBoatFestival'||this.$route.path=='/returnGoodsList'||this.$route.path=='/replacementGoods'||this.$route.path=='/storedValueCard'||this.$route.path=='/modifyMobilePhone'||this.$route.path=='/memberScore'||this.$route.path=='/memberBalance'||this.$route.path=='/myEvaluation'||this.$route.path=='/evaluateOrder'||this.$route.path=='/articleList'||this.$route.path=='/articleItem'||this.$route.path=='/member'||this.$route.path=='/order'||this.$route.path=='/orderDetails'||this.$route.path=='/collections'||this.$route.path=='/footprint'||this.$route.path=='/information'||this.$route.path=='/address'||this.$route.path=='/allTenant'||this.$route.path=='/payPassword'){
          this.isBlock2=false
        }
      }
    }
  }
</script>

<style>
#app {
  /*font-family: "\5FAE\8F6F\96C5\9ED1";*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
   height: 100%; 
   background: #fff;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue